import React from "react";
import Social from "./Social"
import "./css/Home.css"
export default function Home()
{
    let name=["B"," ","R","A","N","I","L","B","A","L","A"]
    name=name.map((letter)=><span className="letters">{letter}</span>)
    return (
        <div className="Home">
            <div className="Name">
                {name}
            </div>
            <Social />
        </div>
    )
}